import {
  Button,
  CloseButton,
  Flex,
  Heading,
  Modal,
  Spinner,
  Text,
} from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import { LearningOutcomesService } from "../../services/LearningOutcomesService";
import CurriculumMapTermSelect from "../CurriculumMap/CurriculumMapTermSelect";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";

const ArchiveModal = ({ outcome, open, setOpen, callback }) => {
  const showNotification = useNotification();
  const [archiving, setArchiving] = useState(false);
  const [effectiveTerm, setEffectiveTerm] = useState({});

  const handleArchive = async () => {
    try {
      if (
        !effectiveTerm.canvas_terms ||
        effectiveTerm.canvas_terms.length === 0
      ) {
        throw new Error("Effective term has no canvas terms associated to it");
      }
      setArchiving(true);

      const term = { ...effectiveTerm, insights_term_id: effectiveTerm.name };
      const earliestCanvasTerm = term.canvas_terms.sort(
        (a, b) => new Date(a.start_at) - new Date(b.start_at)
      )[0];
      await LearningOutcomesService.updateLearningOutcome({
        id: outcome.id,
        archiveTerm: earliestCanvasTerm.id,
      });
      callback(outcome, term);
      setOpen(false);
      showNotification(t("learningOutcomes.archive.archiveSuccess"), "success");
    } catch {
      showNotification(t("learningOutcomes.archive.archiveError"), ERROR);
    } finally {
      setArchiving(false);
    }
  };

  return (
    <Modal
      open={open}
      label={t("learningOutcomes.archive.archiveOutcome")}
      size="medium"
      onExited={() => setEffectiveTerm({})}
    >
      <Modal.Header>
        <Flex justifyItems="space-between">
          <Flex.Item>
            <Heading level="h2" as="h1">
              {t("learningOutcomes.archive.archiveOutcome")}
            </Heading>
          </Flex.Item>
          <Flex.Item>
            <CloseButton
              size="small"
              screenReaderLabel={t("global.close")}
              onClick={() => setOpen(false)}
            />
          </Flex.Item>
        </Flex>
      </Modal.Header>
      <Modal.Body>
        <Flex wrap="wrap" gap="small">
          <Flex.Item>
            <CurriculumMapTermSelect
              id="effective-term-select"
              label={t("learningOutcomes.effectiveTerm")}
              selectHandler={(term) => setEffectiveTerm(term)}
              selectedTermId={effectiveTerm.id}
            />
          </Flex.Item>
          <Flex.Item size="100%">
            <Text>
              <Text weight="bold">
                {t("learningOutcomes.archive.disclaimer")}:{" "}
              </Text>
              {t("learningOutcomes.archive.disclaimerMessage")}
            </Text>
          </Flex.Item>
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <Button margin="0 small 0 0" onClick={() => setOpen(false)}>
          {t("global.cancel")}
        </Button>
        <Button
          color="primary"
          onClick={handleArchive}
          interaction={
            !archiving && !!effectiveTerm.id ? "enabled" : "disabled"
          }
        >
          {archiving ? (
            <Spinner size="x-small" renderTitle={t("global.pleaseWait")} />
          ) : (
            t("learningOutcomes.archive.archive")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ArchiveModal;
